import { useSyncExternalStore } from 'react'

const reducedMotionQuery =
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
        ? window.matchMedia('(prefers-reduced-motion: reduce)')
        : null

function subscribe(callback: () => void): () => void {
    reducedMotionQuery?.addEventListener('change', callback)
    return () => reducedMotionQuery?.removeEventListener('change', callback)
}

function getSnapshot(): boolean {
    return reducedMotionQuery?.matches ?? false
}

function getServerSnapshot(): boolean {
    return false
}

export function usePrefersReducedMotion(): boolean {
    return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
